import { useLocation } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import FactorialCustomBundles from 'modules/billing/components/FactorialCustomBundles'
import FeaturesComparisonSidepanel from 'modules/billing/components/FeaturesComparisonSidepanel'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import DatoPlansProvider from 'modules/onboarding/components/Pricing/DatoPlansContext'
import {
  PricingProvider,
  usePricingContext,
} from 'modules/onboarding/components/Pricing/PricingContext'

const Content = () => {
  const { toggleComparisonPlanSidebar, isComparisonPlanSidebarOpen } = usePricingContext()

  return (
    <ResponsivePage.Body variant="full">
      <FeaturesComparisonSidepanel
        isOpen={isComparisonPlanSidebarOpen}
        onClose={() => {
          toggleComparisonPlanSidebar(false)
        }}
      />
      <FactorialCustomBundles />
    </ResponsivePage.Body>
  )
}

const CustomBundlesHomepage = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    track(trackingEvents.billing.viewCustomBundlesPage, {
      page_path: pathname,
    })
  }, [pathname])

  return (
    <DatoPlansProvider>
      <PricingProvider>
        <Content />
      </PricingProvider>
    </DatoPlansProvider>
  )
}

export default CustomBundlesHomepage
